export const createNoteInitialValues = {
  date_note: null,
  note: ''
};

export const getNotesInitialValues = {
  date_note_from: '',
  date_note_to: ''
};

export const createCommInitialValues = {
  subject: '',
  date: '',
  time: '',
  record: '',
  category: ''
};

export const batchEmailsInitialValues = (users: any[]) => {
  return {
    recipients: users.join(','),
    subject: '',
    description: '',
  };
};
